import { ScholarshipCategoryDto } from '@cradua/data';
import { environment } from 'apps/epims/mrsoftepims/src/environments/environment';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ScholarshipCategoryService {
  url = environment.apiUrl;
  constructor(private http: HttpClient) {}

  getScholarshipCategory(): Observable<ScholarshipCategoryDto[]> {
    return this.http.get<ScholarshipCategoryDto[]>(
      this.url + 'scholarship-category'
    );
  }

  createScholarshipCategory(
    data: ScholarshipCategoryDto[]
  ): Observable<ScholarshipCategoryDto[]> {
    return this.http.post<ScholarshipCategoryDto[]>(
      this.url + 'scholarship-category',
      data
    );
  }
  getSingleScholarshipCategory(id: string): Observable<any> {
    return this.http.get(this.url + 'scholarship-category/' + id);
  }

  updateScholarshipCategory(
    data: ScholarshipCategoryDto[]
  ): Observable<ScholarshipCategoryDto[]> {
    return this.http.post<ScholarshipCategoryDto[]>(
      this.url + 'scholarship-category/update',
      data
    );
  }

  deleteScholarshipCategory(ids: any) {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      body: ids,
    };

    let params = new HttpParams();
    params = params.append('scholarship-category', ids.join(', '));
    return this.http.delete(this.url + 'scholarship-category', httpOptions);
  }
}
